import React, { FunctionComponent } from 'react'
import { displayPhone } from '../../../helpers/displayFormatHelper'
import startCase from 'lodash/startCase'
import capitalize from 'lodash/capitalize'
import classnames from 'classnames'

import { Address } from '../../../core/types'
import { Task, IdentityCheck } from '../types'

export interface Props {
  task: Task
}

const VerifyData: FunctionComponent<Props> = ({ task }) => {
  const { verifiables } = task
  const identityCheck = verifiables[0] as IdentityCheck
  const { flags } = identityCheck

  const reportedIdentityRow = () => {
    let names
    let addresses
    let phones
    let emails
    let source

    if (identityCheck && identityCheck.reportedIdentity) {
      names = identityCheck.reportedIdentity.names
      addresses = identityCheck.reportedIdentity.addresses
      phones = identityCheck.reportedIdentity.phones
      emails = identityCheck.reportedIdentity.emails
      source = identityCheck.source
    }

    return (
      <tr className="table-deluxe__row">
        <th className="table-deluxe__row-header">{source}</th>
        <td className="table-deluxe__cell">
          {names &&
            names.map((name, i) => {
              return (
                <p className="table-deluxe__cell-line" key={i}>
                  {startCase(capitalize(name))}
                </p>
              )
            })}
        </td>
        <td className="table-deluxe__cell">
          {addresses &&
            addresses.map((address, i) => {
              return (
                <address className="table-deluxe__address" key={i}>
                  {capitalize(
                    `${address.line1} ${address.line2 ? address.line2 : ''}, ${
                      address.city
                    },`
                  ) + ` ${address.state} ${address.zip}`}
                </address>
              )
            })}
        </td>
        <td className="table-deluxe__cell">
          {emails &&
            emails.map((email, i) => {
              return (
                <p className="table-deluxe__cell-line" key={i}>
                  {email}
                </p>
              )
            })}
        </td>
        <td className="table-deluxe__cell">
          {phones &&
            phones.map((phone, i) => {
              return (
                <p className="table-deluxe__cell-line" key={i}>
                  {displayPhone(phone)}
                </p>
              )
            })}
        </td>
      </tr>
    )
  }

  const userIdentityRow = () => {
    let name: string | null = null
    let address: Address | null = null
    let phone: string | null = null
    let email: string | null = null

    if (identityCheck.userIdentity) {
      name = identityCheck.userIdentity.name
      address = identityCheck.userIdentity.currentAddress
      phone = identityCheck.userIdentity.phone
      email = identityCheck.userIdentity.email
    }

    return (
      <tr className="table-deluxe__row">
        <th className="table-deluxe__row-header">Blinker</th>
        <td className="table-deluxe__cell">{name}</td>
        <td className="table-deluxe__cell">
          <address className="table-deluxe__address">
            {address
              ? `${address.line1} ${address.line2 ? address.line2 : ''}, ${
                  address.city
                }, ${address.state} ${address.zip}`
              : null}
          </address>
        </td>
        <td className="table-deluxe__cell">{email}</td>
        <td className="table-deluxe__cell">{phone && displayPhone(phone)}</td>
      </tr>
    )
  }

  return (
    <div className="verify-data">
      <table className="table-deluxe">
        <tbody>
          <tr>
            <td />
            <th
              scope="col"
              className={classnames('table-deluxe__col-header', {
                'table-deluxe__col-header--alert': flags.some(
                  (e) => e === 'name'
                ),
              })}
            >
              name
            </th>
            <th
              scope="col"
              className={classnames('table-deluxe__col-header', {
                'table-deluxe__col-header--alert': flags.some(
                  (e) => e === 'address'
                ),
              })}
            >
              address
            </th>
            <th
              scope="col"
              className={classnames('table-deluxe__col-header', {
                'table-deluxe__col-header--alert': flags.some(
                  (e) => e === 'email'
                ),
              })}
            >
              email
            </th>
            <th
              scope="col"
              className={classnames('table-deluxe__col-header', {
                'table-deluxe__col-header--alert': flags.some(
                  (e) => e === 'phone'
                ),
              })}
            >
              phone #
            </th>
          </tr>
          {userIdentityRow()}
          {reportedIdentityRow()}
        </tbody>
      </table>
    </div>
  )
}

export default VerifyData

VerifyData.displayName = 'VerifyData'
